export function hasPermission({ userPermissions, requiredPermissions }) {
  if (!requiredPermissions || !requiredPermissions.length) return true;

  requiredPermissions = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];

  for (const permission of requiredPermissions) {
    if (userPermissions.some((sigla) => sigla === permission)) {
      return true;
    }
  }
  
  return false;
}

export function currentUserHasPermission(requiredPermissions: string[]) {
  const currentUserPermissions = JSON.parse(localStorage.getItem("user"))?.profilesPermissions
  return hasPermission({userPermissions: currentUserPermissions, requiredPermissions: requiredPermissions})
}
